export enum MedicalTypeEnum {
	CONSULTORIO_MEDICO = 1,
	CONSULTORIO_ESPECIALIDADE = 2,
}
